import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { Faq } from 'src/app/funds/shared/_models/faq';


@Component({
  selector: 'app-bloque-faqs',
  templateUrl: './bloque-faqs.component.html',
  styleUrls: ['./bloque-faqs.component.scss'],
  standalone: true,
  imports: [
    SharedModule
  ]
})

export class BloqueFaqsComponent {
 @Input() faqs: Faq[];
 @Input() style: 'light' | 'dark' = 'light';
}
